import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import './loader.css';

class Loader extends React.Component {
	render() {
		return (
			<div className="loader" {...this.props}>
                <FontAwesomeIcon icon={faCircleNotch} className="loader-icon" spin />
            </div>
		);
	}
}

export default Loader;